import type { PlayerResponse, RpmPercentResponse } from '@on3/api';
import clsx from 'clsx';
import { TeamAvatar } from 'components/Image/TeamAvatar';
import { ConditionalLink } from 'components/UI/StarRating/StarRating';
import { Text } from 'components/UI/Typography/Text';
import { type HTMLProps } from 'react';

import styles from './PredictionStatus.module.scss';

interface IPredictionStatus {
  player?: PlayerResponse;
  rpm: RpmPercentResponse[];
  isPlayerCard?: boolean;
}
export const PredictionStatus = ({
  rpm,
  isPlayerCard,
  player,
}: IPredictionStatus & HTMLProps<HTMLDivElement>) => {
  const { slug, recruitmentKey } = player || {};
  const useLink = !!slug && !!recruitmentKey;

  return (
    <ConditionalLink
      className={clsx(styles.predictionsContainer, {
        [styles.playerCardStyles]: isPlayerCard,
      })}
      condition={useLink}
      href={`/db/${slug}/recruiting/${recruitmentKey}/rpm/`}
    >
      {rpm?.map((org) => {
        if (org.organization?.slug) {
          return (
            <div className={styles.prediction} key={org.organization.key}>
              <TeamAvatar
                className={styles.predictionLogo}
                height={30}
                slug={org?.organization?.slug}
                src={org?.organization?.assetUrl}
                width={30}
              />
              {org.percent && (
                <Text className={styles.rpmText} variant="caption">
                  {Math.round(org.percent)}%
                </Text>
              )}
            </div>
          );
        }

        return null;
      })}
    </ConditionalLink>
  );
};
